export default __webpack_public_path__ + "static/media/am4.cdfa58c5.jpg";